export interface PosStaffPinResult {
    isStaffPin: boolean;
    staffEmployeeId: number;
}
